import { QueryClient, QueryKey } from 'react-query';
import { persistOnlyKeys } from './reactQueryPersistence';

export type PrefetchSession = {
  keys: QueryKey[];
  fetchQuery: <TQueryFnData>(
    key: QueryKey,
    queryFn: () => Promise<TQueryFnData>,
    options?: any,
  ) => Promise<TQueryFnData>;
  prefetchQuery: <TQueryFnData>(key: QueryKey, queryFn: () => Promise<TQueryFnData>, options?: any) => Promise<void>;
  persist: () => Promise<void>;
};

export function createPrefetchSession(queryClient: QueryClient): PrefetchSession {
  const keys: QueryKey[] = [];

  const track = (key: QueryKey) => {
    keys.push(key);
    return key;
  };

  return {
    keys,
    fetchQuery: async <TQueryFnData>(key: QueryKey, queryFn: () => Promise<TQueryFnData>): Promise<TQueryFnData> => {
      track(key);
      return queryClient.fetchQuery(key, queryFn);
    },

    prefetchQuery: async <TQueryFnData>(key: QueryKey, queryFn: () => Promise<TQueryFnData>): Promise<void> => {
      track(key);
      await queryClient.prefetchQuery(key, queryFn);
    },

    persist: async () => {
      await persistOnlyKeys(queryClient, keys);
    },
  };
}
